import { createUseStyles } from 'react-jss';

import { colors } from 'resources/styles/colors';

import { ViboTheme } from 'types/theme';

const useStyles = createUseStyles((theme: ViboTheme) => ({
  googleLoginButton: {
    '& .prefixIcon': {
      left: '8px',
      top: '50%',
      position: 'absolute',
      display: 'block',
      transform: 'translate(-2.5px, -50%)',
      backgroundColor: colors.white,
      padding: '2.5px',
      borderRadius: '1px',

      '& svg': {
        width: '13px!important',
        height: '13px!important',
      },

      '@media screen and (min-width: 1441px)': {
        left: '8px',
      },
    },
  },
}));

export default useStyles;
